module.exports = "/assets/data/02f1f3eda3620f63fceb2e9a648a01b1-DD8.data.json";